import { useQuery, useQueryClient } from "@tanstack/react-query";

import { NOT_FOUND_ERROR } from "app/pages/activation/components/RankWidget/config";
import { ACTIVATION_OBJECT_QUERY_KEY } from "app/pages/activation/queries/data/useActivationObjectQuery";
import { createActivationApi } from "app/pages/activation/services/api";

const GET_RT_CAMPAIGN_QUERY_KEY = "GET_RT_CAMPAIGN_QUERY_KEY";

export const useGetRTCampaignQuery = (projectId: string | undefined, campaignId: string, isQueryEnabled = true) => {
    const queryClient = useQueryClient();
    const isEnabled = Boolean(projectId && campaignId && isQueryEnabled);

    return useQuery({
        queryKey: [GET_RT_CAMPAIGN_QUERY_KEY, projectId, campaignId],
        queryFn: async () => {
            if (typeof projectId !== "string" || projectId.length < 1) {
                return undefined;
            }

            try {
                const { rankTracker } = createActivationApi();

                return await rankTracker.getCampaign(projectId);
            } catch (error: unknown) {
                const message = error instanceof Error ? error.message : "";

                if (message === NOT_FOUND_ERROR) {
                    queryClient.invalidateQueries({ queryKey: [ACTIVATION_OBJECT_QUERY_KEY, projectId] });
                }
            }
        },
        enabled: isEnabled,
        refetchOnWindowFocus: false,
        retry: 1,
    });
};
